import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { COWTUXSharedModule } from '@cowtux/shared.module';

import { ContentComponent } from 'app/layout/components/content/content.component';

@NgModule({
    declarations: [
        ContentComponent
    ],
    imports     : [
        RouterModule,
        COWTUXSharedModule
    ],
    exports     : [
        ContentComponent
    ]
})
export class ContentModule
{
}
